module.exports = __webpack_public_path__ + "media/images/icons/country_flags/bf-a3957b0a98236111e2377ac4bc638574.svg";